// components/charts/TopCardWithModal.jsx
import React from "react";
import { Card, CardBody } from "../card/card.jsx";
import Chart from "react-apexcharts";
import { ModalComponent } from "../expand/expandmodal.jsx";

export function safeFixed(val, digits = 2) {
  if (val == null || isNaN(val)) return "0";
  return Number(val).toFixed(digits);
}

const TopCardWithModal = ({
  stat,        // { title, total, chartType, chartHeight, chartData, info }
  loading,
  chartOptions,
  modalContent, // JSX to show in ModalComponent
}) => {
  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex fw-bold small mb-3 align-items-center">
          <span className="flex-grow-1">{stat?.title || "..."}</span>
          <ModalComponent cardBodyContent={modalContent} />
        </div>
        <div className="row align-items-center mb-2">
          <div className="col-7">
            <h3 className="mb-0">
              {loading ? (
                <div
                  className="spinner-border"
                  role="status"
                  style={{ color: 'var(--bs-theme)' }}
                >
                  <span className="visually-hidden">Loading stat...</span>
                </div>
              ) : (
                stat?.total !== undefined && stat?.total !== null
                  ? parseInt(stat.total).toLocaleString('en-US')
                  : "—"
              )}
            </h3>
          </div>
          <div className="col-5">
            <div className="mt-n2 position-relative" style={{ minHeight: stat?.chartHeight || 60 }}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100" style={{ minHeight: stat?.chartHeight || 60 }}>
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ color: 'var(--bs-theme)' }}
                  >
                    <span className="visually-hidden">Loading chart...</span>
                  </div>
                </div>
              ) : stat?.chartType === "bar" ? (
                <Chart
                  type="bar"
                  height={stat.chartHeight}
                  options={chartOptions.bar}
                  series={stat.chartData}
                />
              ) : stat?.chartType === "line" ? (
                <Chart
                  type="line"
                  height={stat.chartHeight}
                  options={chartOptions.line}
                  series={stat.chartData}
                />
              ) : null}
            </div>
          </div>
        </div>
        <div className="small text-inverse text-opacity-50 text-truncate">
          {stat?.info?.map((info, idx) => (
            <div key={idx} title={info.tooltip || ""}>
              <i className={info.icon}></i> <span>{info.text}</span><span style={{ color: info.color || ''}}>{info.text2}</span>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default TopCardWithModal;
